import moment from "moment";
import MessageModal from "../common/MessageModal.vue";
import { getData, createData, updateData, deleteData } from "@/services/axios";
export default {
  name: "MonthlyComment",
  components: {
    MessageModal
  },
  filters: {
    localYearMonth: function (v) {
      return moment(v).format("YYYY年MM月");
    }
  },
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    yearMonth: {
      type: String,
      default: ""
    }
  },
  data: function () {
    return {
      showModal: false,
      comment: "",
      attendanceMonthlyComment: {},
      comments: []
    };
  },

  created() {
    this.getComments();
  },

  methods: {
    getComments() {
      getData("attendance_monthly_comments?student_id=" + this.student.id).then(data => {
        this.comments = data.items;

        if (this.comments.find(v => v.start_of_month === moment(this.yearMonth).format("YYYY-MM-DD"))) {
          this.attendanceMonthlyComment = this.comments.find(v => v.start_of_month === moment(this.yearMonth).format("YYYY-MM-DD"));
          this.comment = this.attendanceMonthlyComment.comment;
        }

        console.log(data.items);
      }).catch(error => {
        console.log(error);
      });
    },

    handleSubmit() {
      let successMessage, successTitle, failMessage, failTitle;
      new Promise((resolve, reject) => {
        if (!this.attendanceMonthlyComment.id) {
          successTitle = "登録完了";
          successMessage = "コメントを登録しました";
          failTitle = "登録失敗";
          failMessage = "コメントを登録できませんでした";
          createData("attendance_monthly_comments", {
            student_id: this.student.id,
            comment: this.comment,
            start_of_month: moment(this.yearMonth).startOf("month").format("YYYY-MM-DD")
          }).then(v => resolve(v)).catch(v => reject(v));
        } else {
          successTitle = "更新完了";
          successMessage = "コメントを更新しました";
          failTitle = "更新失敗";
          failMessage = "コメントを更新できませんでした";
          updateData("attendance_monthly_comments/" + this.attendanceMonthlyComment.id, {
            student_id: this.student.id,
            comment: this.comment,
            start_of_month: moment(this.yearMonth).startOf("month").format("YYYY-MM-DD")
          }).then(v => resolve(v)).catch(v => reject(v));
        }
      }).then(() => {
        this.$store.dispatch("commitModalMessage", {
          message: successMessage,
          title: successTitle
        });
      }).catch(error => {
        this.$store.dispatch("commitModalMessage", {
          message: failMessage,
          title: failTitle
        });
        console.log(error);
      }).finally(() => {
        this.showModal = true;
      });
    },

    handleDelete() {
      deleteData("attendance_monthly_comments/" + this.attendanceMonthlyComment.id).then(data => {
        console.log(data.items);
        this.$store.dispatch("commitModalMessage", {
          message: "コメントを削除しました",
          title: "削除完了"
        });
      }).catch(error => {
        this.$store.dispatch("commitModalMessage", {
          message: "コメントを削除できませんでした",
          title: "削除失敗"
        });
        console.log(error);
      }).finally(() => {
        this.showModal = true;
      });
    },

    closeModal() {
      this.showModal = false;
      this.$emit("close-modal");
      this.getComments();
    }

  }
};